import N2StylesModal from "../components/N2StylesModal";

export default class ClientsDigitalJobs {
  constructor(params) {
    this.params = params;
    this.role = params.role || null;
  }

  new() {
    if (this.role === "area_director") {
      // this element only exists if the client has not given permission to post to Facebook
      new N2StylesModal(".js-missing-client-permission-modal");
    }
  }
}
